<template>
  <Container>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Employee Signup</h5>
                  <p>Enter the following information to complete your registeration</p>
                </div>
              </div>

              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>

          <div class="card-body pt-0">
            <router-link tag="a" to="/">
              <div class="avatar-md profile-user-wid mb-4">
                <span class="avatar-title rounded-circle bg-light">
                  <img src="@/assets/images/logo.svg" alt class="rounded-circle" height="34" />
                </span>
              </div>
            </router-link>

            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <b-form class="p-2" @submit.prevent="handleSubmit(onRegister)">
                <b-row>
                  <b-col sm="6">
                    <b-form-group label="First name" label-for="first_name">
                      <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                        <b-form-input
                          id="first_name"
                          v-model="employee.first_name"
                          placeholder="Enter first name"
                        ></b-form-input>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6">
                    <b-form-group label="Last Name" label-for="last_name">
                      <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                        <b-form-input
                          id="last_name"
                          v-model="employee.last_name"
                          placeholder="Enter last Name"
                        ></b-form-input>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-form-group label="Phone number" label-for="phone_number">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-input
                      id="phone_number"
                      v-model="employee.phone_number"
                      placeholder="Enter phone #"
                    ></b-form-input>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group label="Password" label-for="password">
                  <ValidationProvider vid="password" rules="required|min:6" v-slot="{ errors }">
                    <b-form-input
                      id="password"
                      v-model="employee.password"
                      type="password"
                      placeholder="Enter password"
                    ></b-form-input>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group label="Password Confirmation" label-for="confirmation">
                  <ValidationProvider rules="required|password:@password" v-slot="{ errors }">
                    <b-form-input
                      id="confirmation"
                      v-model="employee.password_confirmation"
                      type="password"
                      placeholder="Repeat password"
                    ></b-form-input>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>

                <div class="mt-4">
                  <b-button type="submit" variant="primary" class="btn-block">Register</b-button>
                </div>

                <div class="mt-4 text-center">
                  <p class="mb-0">
                    By registering you agree to the Skote
                    <a href="javascript: void(0);" class="text-primary">Terms of Use</a>
                  </p>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Skote. Crafted with <i class="mdi mdi-heart text-danger"></i> by
            Themesbrand
          </p>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/auth";
import appConfig from "@/app.config";
import { acceptInvite } from "@/store/api";
import { mapState, mapActions } from "vuex";

export default {
  page: {
    title: "Invitation",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
  },

  data() {
    return {
      employee: {
        first_name: "",
        last_name: "",
        password: "",
        password_confirmation: "",
        invitation_token: this.$route.query.invitation_token,
      },
    };
  },

  computed: {
    ...mapState(["loginUser"]),
  },

  methods: {
    ...mapActions(["login"]),

    onRegister() {
      acceptInvite(this.employee).then((response) => {
        this.login(response);
        this.$router.push("/");
      });
    },
  },
};
</script>
